/** MUI Modal default is 1300; keep feedback/dev overlays above page dialogs. */
export const DEV_SHELL_Z_INDEX = 1600;
export const FEEDBACK_DIALOG_Z_INDEX = 1700;
export const SESSION_REFRESH_DIALOG_Z_INDEX = 1800;

export function feedbackDialogSlotProps() {
  return {
    root: { sx: { zIndex: FEEDBACK_DIALOG_Z_INDEX } },
  };
}
